<!-- <h4 class="title">Follow up Save</h4> -->
<mat-icon style="text-align: left;width: 100%;margin-bottom: 13px;margin-top: -10px;" mat-button (click)="close()">arrow_back_ios</mat-icon>

<app-user-new-settlement></app-user-new-settlement>

<!-- <div class="row" style="padding: 0px 0px 23px 10px;">
    <div class="col-md-3">
      <h5 class="form-lable">Loan No./Account No.:</h5>
      <input type="text" pInputText placeholder="" value="">
    </div>
    <div class="col-md-3">
      <h5 class="form-lable">Customer Name:</h5>
      <input type="text" pInputText placeholder="" value="">
    </div>
    <div class="col-md-3">
      <h5 class="form-lable">DPD>=:</h5>
      <input type="text" pInputText placeholder="" value="">
    </div>
    <div class="col-md-3">
      <h5 class="form-lable">Card Number:</h5>
      <input type="text" pInputText placeholder="" value="">
    </div>
    <div class="col-md-3">
      <h5 class="form-lable">Branch:</h5>
      <input type="text" pInputText placeholder="" value="">
    </div>
    <div class="col-md-3">
      <h5 class="form-lable">Product:</h5>
      <input type="text" pInputText placeholder="" value="">
    </div>
    <div class="col-md-3">
      <h5 class="form-lable">Bucket:</h5>
      <input type="text" pInputText placeholder="" value="">
    </div>
    <div class="col-md-3">
      <h5 class="form-lable">Queue:</h5>
      <input type="text" pInputText placeholder="" value="">
    </div>
    <div class="col-md-3">
      <h5 class="form-lable">Car Type:</h5>
      <input type="text" pInputText placeholder="" value="">
    </div>
    <div class="col-md-3">
      <h5 class="form-lable">POS / Curr Acc Bal:</h5>
      <input type="text" pInputText placeholder="" value="">
    </div>
    <div class="col-md-3">
      <h5 class="form-lable">Sub Product Code:</h5>
      <input type="text" pInputText placeholder="" value="">
    </div>
    <div class="col-md-3">
      <h5 class="form-lable">Scheme:</h5>
      <input type="text" pInputText placeholder="" value="">
    </div>
    
    <div class="col-md-3 mt-20">
            <button type="button" class="btn btn-primary">Save</button>
       </div>

  </div> -->